import React, { useState } from 'react'
import styled from 'styled-components'

// styles
import colors from '../../../styles/colors'

// images
import UpActiveImg from '../../../assets/image/scroll/ic-up-a.svg'
import UpInactiveImg from '../../../assets/image/scroll/ic-up-i.svg'

import DownActiveImg from '../../../assets/image/scroll/ic-down-a.svg'
import DownInactiveImg from '../../../assets/image/scroll/ic-down-i.svg'

const ScrollBtnRef = ({ onClickUp, onClickDown }) => {
  const [activeIndex, setActiveIndex] = useState(null)

  return (
    <Container>
      <Wrapper>
        <Up
          onMouseOut={() => setActiveIndex(null)}
          onMouseOver={() => setActiveIndex(0)}
          onClick={onClickUp}
        >
          <img src={activeIndex === 0 ? UpActiveImg : UpInactiveImg} />
        </Up>
        <Down
          onMouseOut={() => setActiveIndex(null)}
          onMouseOver={() => setActiveIndex(1)}
          onClick={onClickDown}
        >
          <img src={activeIndex === 1 ? DownActiveImg : DownInactiveImg} />
        </Down>
      </Wrapper>
    </Container>
  )
}

export default ScrollBtnRef

const Container = styled.div`
  position: fixed;
  display: flex;
  z-index: 9999;

  right: 6px;
  top: 449px;
  align-items: center;

  @media ${(props) => props.theme.mobile} {
    display: none;
  }
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const Up = styled.div`
  width: 40px;
  height: 60px;
  border: 1px solid ${colors.G3};
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.6);

  &:hover {
    background-color: #17a61c;
  }

  img {
    width: 18px;
    height: 18px;
  }
`

const Down = styled.div`
  margin-top: 6px;
  width: 40px;
  height: 60px;
  border: 1px solid ${colors.G3};
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.6);

  &:hover {
    background-color: #17a61c;
  }

  img {
    width: 18px;
    height: 18px;
  }
`
